import React, { Component } from 'react';
import { Typography, IconButton, Button, Box } from '@material-ui/core';
import '../../styles/Globales.scss';
import '../../styles/Comprobante.scss';
import '../../styles/CuadroResumen.scss';
import appStore from '../../stores/AppStore';
import ViewConstants from '../../utils/ViewConstants';
import * as EstadosSolicitud from '../../utils/EstadosSolicitud';
import * as EstadosBO from '../../utils/EstadosBO';
import PopupConfirmacionLecturaOfertaComponent from './PopupConfirmacionLecturaOfertaComponent';
import PopupBotonesPDf from './PopupBotonesPdf'

const SOLICITUD=1;
const OFERTA_COMPLETA=2;
const OFERTA_ACEPTADA=3;


export default class CuadroResumenComponent extends Component {
  state = {
    openConfirmacion: false,
    openPopuPdf:false
  };

  verOferta = () => {
    if (this.props.solicitud.estadoId === EstadosSolicitud.OFERTA_DISPONIBLE) {
      this.showConfirmacion();
    } else {
      appStore.ofertasStore.solicitud = this.props.solicitud;
      appStore.ofertasStore.obtenerProductosAPortar(this.onProductosPortarCargados);
    }
  };

  revisarOferta = () => {
    appStore.ofertasStore.solicitud = this.props.solicitud;
    appStore.changeNavigation(ViewConstants.ETAPA_OFERTA_ACEPTADA);
  };

  showConfirmacion = () => {
    this.setState({ openConfirmacion: true });
  };

  onHidePopupConfirmacion = () => {
    appStore.ofertasStore.solicitud = this.props.solicitud;
    appStore.ofertasStore.obtenerProductosAPortar(this.onProductosPortarCargados);
  };

  onProductosPortarCargados = () => {
    appStore.changeNavigation(ViewConstants.ETAPA_CONFIRMACION_PRDUCTOS);
  };

  verDocumentos=()=>{
    this.setState({openPopuPdf:true});
  }

  descargarPdf = (tipoDoc) => {
    if(tipoDoc===SOLICITUD){
      appStore.solicitarNuevaPortalidadStore.generarCertificadoPorId(this.props.solicitud.id, this.onDescargaPdfSolicitud);
    }else if(tipoDoc===OFERTA_COMPLETA){
      appStore.ofertasStore.generarPdfOferta(this.props.solicitud.id, this.onDescargaPdfOferta);
    }else if(tipoDoc===OFERTA_ACEPTADA){
      appStore.ofertasStore.generarPdfOfertaAceptada(this.props.solicitud.id, this.onDescargaPdfOfertaAceptada);
    }
  };

  onDescargaPdfSolicitud = (pdf) => {
    const pdfName = 'data:application/pdf;base64,' + pdf;
    const link = document.createElement('a');
    link.href = pdfName;
    const nombreArchivo = 'sp' + this.props.solicitud.id;
    link.setAttribute('download', nombreArchivo);
    link.click();
  };

  onDescargaPdfOferta = (pdf) => {
    const pdfName = 'data:application/pdf;base64,' + pdf;
    const link = document.createElement('a');
    link.href = pdfName;
    const nombreArchivo = 'oferta_portabilidad_' + this.props.solicitud.id;
    link.setAttribute('download', nombreArchivo);
    link.click();
  };

  onDescargaPdfOfertaAceptada = (pdf) => {
    const pdfName = 'data:application/pdf;base64,' + pdf;
    const link = document.createElement('a');
    link.href = pdfName;
    const nombreArchivo = 'oferta_acepta_' + this.props.solicitud.id;
    link.setAttribute('download', nombreArchivo);
    link.click();
  };

  closePopupPdf=()=>{
    this.setState({openPopuPdf:false});
  }

  renderBotonAccion = (estadoId) => {
    let result = <div className="contenedorBtnOferta"></div>;
    if (estadoId === EstadosSolicitud.OFERTA_DISPONIBLE) {
      result = (
        <div className="contenedorBtnOferta">
          <Button className="btnRipleyOferta" onClick={this.verOferta}>
            Tienes ofertas disponibles!
          </Button>
        </div>
      );
    } else if (estadoId === EstadosSolicitud.OFERTA_ACEPTADA || estadoId === EstadosSolicitud.ACEPTACION_PARCIAL) {
      result = (
        <div className="contenedorBtnOferta">
          <Button className="btnRipleyOferta" onClick={this.revisarOferta}>
            Revisar Oferta
          </Button>
        </div>
      );
    }
    return result;
  };

  getTextoDetalle=(estadoBo,estadoSolicitud)=>{
    let result;
    if(estadoSolicitud!==EstadosSolicitud.OFERTA_EXPIRADA_POR_INACTIVIDAD){
      switch(estadoBo){
        case 4:result='En proceso de actualización de deuda. Aún no te acerques a sucursal Banco.';break;
        case 8:result='En proceso de actualización de deuda. Aún no te acerques a sucursal Banco.';break;
        case 10:result='Actualización de deuda terminada, puede ir a terminar el proceso a la sucursal.';break;
        case 11:result='tu situación de deuda cambió. Ya no tenemos una oferta para ti. Intenta ingresar una nueva solicitud de portabilidad.';break;
        default:result='';break;
      }
    }
    if(!result||result===''){
      switch(estadoSolicitud){
        case EstadosSolicitud.CANCELADA:result='Ingresa una nueva solicitud de portabilidad.';break;
        case EstadosSolicitud.INGRESADA:result='Estamos evaluando tu solicitud.';break;
        case EstadosSolicitud.GENERACION_OFERTA:result='Estamos evaluando tu solicitud.';break;
        case EstadosSolicitud.OFERTA_EXPIRADA_POR_INACTIVIDAD:result='La oferta que teníamos para ti expiró. Ingresa nuevamente y haz una nueva solicitud.';break;
        default:result='';break;
      }
    }
    return result;
  }

  getColorSemaforo=(estadoBo)=>{
    let result;
    switch(estadoBo){
      case 4:result='amarilloSolicitud';break;
      case 8:result='amarilloSolicitud';break;
      case 10:result='verdeSolicitud';break;
      case 11:result='rojoSolicitud';break;
      default:result='';break;
    }
    return result;
  }

  getTituloEstado=(estadoId,estadoBoId,nombreEstado)=>{
    let result = nombreEstado.charAt(0).toUpperCase() + nombreEstado.toLowerCase().slice(1);
    switch(estadoId){
      case EstadosSolicitud.CANCELADA:
        if(estadoBoId===EstadosBO.RETRACTO_DE_OFERTA_POR_BANCO){
          result='Retracto de Oferta por Banco';
        }else{
          result='Solicitud Inválida';
        }
        break;
      case EstadosSolicitud.OFERTA_NO_DISPONIBLE:
        result='No tenemos una oferta para ti';
        break;
      case EstadosSolicitud.OFERTA_CANCELADA:
        result='Arrepentimiento de oferta cursado';
        break;
      case EstadosSolicitud.GENERACION_OFERTA:
        result='Solicitud Ingresada';
        break;
      case EstadosSolicitud.INGRESADA:
        result='Solicitud Ingresada';
        break;
      case EstadosSolicitud.OFERTA_EXPIRADA_POR_INACTIVIDAD:
        result='Oferta expirada';
        break;
      default:
        break;
    }
    return result;
  }

  render() {
    const sol = this.props.solicitud;
    const estado = this.getTituloEstado(sol.estadoId,sol.estadoBoId,sol.nombreEstado)
    const colorSemaforo=this.getColorSemaforo(this.props.solicitud.estadoBoId);
    return (
      <div className="cuadroResumen">
        <Typography className="etiquetaBanco" component="div">
          <Box> Desde {sol.nombreBancoActual} </Box>{' '}
        </Typography>{' '}
        <div className="seccionLinea">
          <div className="titulosemaforo"><div className="contenedorSemaforo"><div className={colorSemaforo}></div></div><Typography className="estadoOferta"> {estado} </Typography></div>{' '}
          <IconButton>
            <img className="pdfmorado" src={require('../../images/pdfmorado.svg')} alt="pfd" onClick={this.verDocumentos} />{' '}
          </IconButton>{' '}
        </div>{' '}
        <Typography className="textosolicitud">
          {this.getTextoDetalle(this.props.solicitud.estadoBoId,this.props.solicitud.estadoId)}
        </Typography>
        <Typography className="idsolicitud">
          Id solicitud: <strong> {sol.id} </strong>{' '}
        </Typography>{' '}
        {this.renderBotonAccion(sol.estadoId)}
        <PopupConfirmacionLecturaOfertaComponent
          open={this.state.openConfirmacion}
          onContinuar={this.onHidePopupConfirmacion}
          onCancelar={() => {
            this.setState({ openConfirmacion: false });
          }}
          onDescargarDocumento={this.descargarPdf}
        />
        <PopupBotonesPDf open={this.state.openPopuPdf}
        estadoSolicitud={sol.estadoId} 
        onClose={this.closePopupPdf}
        onDocumentoSeleccionado={this.descargarPdf}/>
      </div>
    );
  }
}
